import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';

// TV module pages
import TVDashboard    from './modules/tv/DashboardPage';
import TVClients      from './modules/tv/ClientsPage';
import TVClientDetail from './modules/tv/ClientDetail';
import TVPlanEditor   from './modules/tv/PlanEditor';
import TVUsers        from './modules/tv/UsersPage';

// Digital module pages
import DigitalDashboard    from './modules/digital/DigitalDashboard';
import DigitalClients      from './modules/digital/DigitalClientsPage';
import DigitalClientDetail from './modules/digital/DigitalClientDetail';
import DigitalPlanEditor   from './modules/digital/DigitalPlanEditor';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontFamily:"'Inter',sans-serif", color:'#9A8A7A' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const [module, setModule] = useState(() => localStorage.getItem('plan_module') || 'tv');

  function handleSetModule(m) {
    setModule(m);
    localStorage.setItem('plan_module', m);
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/" element={
        <PrivateRoute>
          <Layout module={module} setModule={handleSetModule} />
        </PrivateRoute>
      }>
        {module === 'tv' && <>
          <Route index element={<TVDashboard />} />
          <Route path="clients" element={<TVClients />} />
          <Route path="clients/:id" element={<TVClientDetail />} />
          <Route path="plans/:id" element={<TVPlanEditor />} />
          <Route path="users" element={
            <PrivateRoute roles={['admin', 'manager']}><TVUsers /></PrivateRoute>
          } />
        </>}

        {module === 'digital' && <>
          <Route index element={<DigitalDashboard />} />
          <Route path="clients" element={<DigitalClients />} />
          <Route path="clients/:id" element={<DigitalClientDetail />} />
          <Route path="plans/:id" element={<DigitalPlanEditor />} />
          <Route path="users" element={
            <PrivateRoute roles={['admin', 'manager']}><TVUsers /></PrivateRoute>
          } />
        </>}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
